const LOCAL_BFF_BASE_URL = 'http://localhost:8000';

const getEnv = (key) =>
  (typeof window !== 'undefined' && window._env_ ? window._env_[key] : undefined)
  ?? process.env[key] 
  ?? '';

export const normalizeBffBaseUrl = (raw) => {
  const value = (raw || '').trim();
  if (!value) return '';
  const withoutTrailingSlash = value.replace(/\/+$/, '');
  if (/^https?:\/\//i.test(withoutTrailingSlash)) {
    return withoutTrailingSlash;
  }
  return `https://${withoutTrailingSlash}`;
};

const isLoopbackBrowser = () => {
  if (typeof window === 'undefined' || !window.location) return false;
  const host = (window.location.hostname || '').toLowerCase();
  return ['localhost', '127.0.0.1', '0.0.0.0', '::1', '[::1]'].includes(host);
};

export const getBffBaseUrl = () => {
  const configured = normalizeBffBaseUrl(getEnv('REACT_APP_API_BASE_URL'));
  if (configured) return configured;
  return isLoopbackBrowser() ? LOCAL_BFF_BASE_URL : '';
};
